import bg from "../assets/images/main-slider/banner-bg-shape-3.png";

export const bannerTwo = [
  {
    id: 2,
    bg: "2.jpg",
    subtitle: "Welcome",
    title: "UI\nDesigning",
  },
  {
    id: 3,
    bg: "3.jpg",
    subtitle: "Welcome",
    title: "Web\nDevelopment",
  },
  {
    id: 4,
    bg: "4.jpg",
    subtitle: "Welcome",
    title: "Mobile\nDevelopment",
  },
  {
    id: 1,
    bg: "1.jpg",
    subtitle: "Welcome",
    title: "Smart Web\nSolutions",
  },






];

export const bannerOne = {
  bg,
  dayRange: "mon - fri",
  timeRange: "9am - 7pm",
  socials: [
    {
      id: 1,
      to: "#",
      title: "Twitter",
    },
    {
      id: 2,
      to: "#",
      title: "Facebook",
    },
    {
      id: 3,
      to: "#",
      title: "Youtube",
    },
  ],
  banners: bannerTwo,
  bannersTwo: [
    {
      id: 1,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "This ethos drives us to provide our clients with bespoke solutions that transcend their expectations.",
    },
    {
      id: 2,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "This ethos drives us to provide our clients with bespoke solutions that transcend their expectations.",
    },
    {
      id: 3,
      bg: "image-1.jpg",
      title: "Best Digital\nMarketing\nAgency",
      text: "This ethos drives us to provide our clients with bespoke solutions that transcend their expectations.",
    },
  ],
};
